<template lang="pug">
  div.top
    div.floor(:style="styFloor()")
      div.area
        Space
        div.area-inr(:style="area()")
          Items
          Rails
          Slits
</template>

<script>
import Items from './Items.vue';
import Slits from './Slits.vue';
import Rails from './Rails.vue';
import Space from './Space.vue';
export default{
  name: 'Top',
  components: {
    Items,
    Slits,
    Rails,
    Space
  },
  data () {
    return {
      left: 0
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    },
    view () {
      this.update();
    }
  },
  methods: {
    update () {
      this.set = this.sets[this.number];
      // すべて更新
      if (this.sets.length > 0 && this.set !== undefined) {
        this.width = this.set.size[0];
        this.height = this.set.size[1];
        this.depth = this.set.size[2];
        this.left = this.c2p(this.set.left);
      }
    },
    area () {
      return {
        left: (this.left) + 'px',
        width: (this.c2p(this.width)) + 'px',
        height: (this.c2p(this.depth)) + 'px'
      };
    },
    styFloor () {
      return {
        backgroundPosition: 'left ' + this.left + 'px top'
      };
    }
  },
  created () {
    this.update();
  },
  mounted () {
  }

};
</script>

<style lang="stylus" scoped>
  .top
    display flex
    justify-content center
    align-items center
    font-size 20px
    font-weight bold
    position absolute
    left 0
    right 0
    top 0
    bottom 0
  .floor
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    z-index 1
    background url("../../assets/bg_grid_top.svg") left top
  .area
    position absolute
    left 100px
    right 0
    top 200px
    bottom 0
    z-index 2
    &:after
      content ""
      display block
      height 5px
      position absolute
      left -100px
      right 0
      top -5px
      background-color #aaaaaa
  .area-inr
    position absolute
    left 0
    top 0
    /*background-color #ff000033*/
    width 100px
    height 100px
</style>



// WEBPACK FOOTER //
// src/components/top/Top.vue